export default {
    STOCK_DELIVERY: 2,
    DOWNLOAD_LIST_PIUTANG: 206,
    SETTLE_HUTANG_DEPOSIT: 207,
    CREATE_EXTERNAL_INVENTORY: 301,
    CUSTOMER_EDIT_PIUTANG: 208,
    CUSTOMER_VIEW: 209,
    CUSTOMER_CREATE: 210,
    CUSTOMER_EDIT: 211,
    CUSTOMER_RESET_PIN: 228,
    CUSTOMER_EDIT_OVERLIMIT: 212,
    CUSTOMER_RESET_FACE_MASTER: 229,
    EDIT_DELETE_ADJ_KERUSAKAN: 110,
    SIMULASI_ADJUSTMENT_KERUSAKAN: 1700,
    APPROVE_GOLD: 1801,
    CREATE_EXTERNAL_INVENTORY_GOLD: 1803,
    CHANGE_CUSTOMER_INVOICE_FINALIZED: 214,
    UPDATE_CATALOG: 1,
    ADJUSTMENT_BARCODE_INVOICE: 215,
    ADJUSTMENT_BARCODE_INVOICE_FINALIZE: 216,
    INSERT_FOVID_SERVICE: 302,
    DELETE_FOVID_SERVICE: 303,
    PENJUALAN_PEMBAYARAN_PIUTANG: 218,
    CUSTOMER_BLACKLIST: 212,
    CUSTOMER_ALLOW_MANUAL_PAYMENT: 219,
    PENJUALAN_FLASH_SALE: 217,
    PEI_RECEIVING: 3000,
    GOLD_RECEIPT_VARIANCE: 3001,
    GOLD_RECEIPT_VARIANCE_AUDITOR: 3002,
    CHAT_TEMUAN_EMAS: 3004,
    ADD_ADJ_INVENTORY: 306,
    DELETE_ADJUSTMENT_INVENTORY: 307,
    EDIT_ADJUSTMENT_PRICE: 308,
    ADD_FOTO_ADJ: 706,
    DELETE_FOTO_ADJ: 704,
    RESET_ACCESSORIES: 707,
    CHANGE_WAREHOUSE_INVOICE: 220,
    FINALISASI_PENJUALAN_MARKETPLACE: 225,
    EDIT_PENJUALAN_MARKETPLACE: 226,
    PENJUALAN_MARKETPLACE_RETUR: 227,
    EDIT_ADJUSTMENT_AFTER_SOLD: 309,
    PENJUALAN_REQUEST_INVOICE_VOID: 223,
    PENJUALAN_COPY_INVOICE_VOID: 222,
    LAPORAN_SALES_RETUR_BARANG: 1003,
    LAPORAN_TRANSAKSI_CUSTOMER: 1004,
    LAPORAN_TRANSAKSI_PEMBAYARAN: 1005,
    LAPORAN_PENERIMAAN_BARANG: 1006,
    LAPORAN_PENERIMAAN_BARANG_EXTERNAL: 1007,
    LAPORAN_PERPINDAHAN_BARANG: 1008,
    LAPORAN_CATALOG_CUSTOMER: 1009,
    LAPORAN_TUGAS_ADMIN: 1010,
    LAPORAN_KIRIM_BALIK_PGI: 1011,
    LAPORAN_KIRIM_INVEN_PGI: 1012,
    LAPORAN_ADJUSTMENT_BARCODE: 1013,
    LAPORAN_ADJUSTMENT_KERUSAKAN: 1014,
    LAPORAN_TITIP_JUAL: 1015,
    LAPORAN_PENJUALAN_MARKETPLACE: 1016,
    LAPORAN_PENERIMAAN_BARANG_EMAS_PGI: 1017,
    LAPORAN_PENERIMAAN_BARANG_EXTERNAL_EMAS: 1018,
    LAPORAN_SALES_RETUR_EMAS: 1019,
    LAPORAN_SALES_AUDIT: 1020,
    LAPORAN_SALES_AUDIT_EMAS: 1021,
    LAPORAN_STOCK_WAREHOUSE: 1022,
    LAPORAN_MARKETPLACE_RETUR: 1023,
    LAPORAN_PENERIMAAN_BARANG_EMAS_PEI: 1024,
    LAPORAN_PENERIMAAN_BARANG_EMAS_RBE: 1029,
    LAPORAN_SALES_SELISIH_EMAS: 1025,
    LAPORAN_SALES_RETUR_MARKETPLACE: 1026,
    LAPORAN_INVENTORY_RESET: 1027,
    INVENTORY_EMAS: 1802,
    SIMULASI_HARGA_EMAS: 1804,
    GOLD_MELT: 1805,
    LAPORAN_LEBUR_EMAS: 1028,
    LAPORAN_TEMUAN_EMAS: 1030,
    LAPORAN_TEMUAN_ELEKTRONIK: 1031,
    MASTER_PPH: 1807,
    MASTER_MATERAI: 1808,
    CONCERT_SALES_ADMIN: 4001,
    CONCERT_SALES: 4000,
    RESET_INVENTORY_GOLD: 3005,
    APPROVE_RESET_INVENTORY_GOLD: 3006,
    ADJUSTMENT_BARCODE_HITUNG_ULANG: 501,
    MASTER_ADJ_HARGA_GRADE_S: 113,
    APPROVE_BARANG: 701,
    INVENTORY_VARIANCE: 902,
    INVENTORY_VARIANCE_AUDITOR: 903,
    INVENTORY_VARIANCE_CHAT: 904,
    APPROVE_CONSIGNMENT: 705,
};
